module.exports = __webpack_public_path__ + "static/media/utl.8763ebbe.svg";